{
	"error": {
		"message": "Ocurrió un error al procesar su solicitud. Por favor, intente nuevamente."
	},
	"placeholder": "Escribe tu mensaje...",
	"initialMessage": "Hola, ¿cómo puedo ayudarte?"
}
